import { render } from "./ProjectOverviewBoard.vue?vue&type=template&id=c4534416&scoped=true"
import script from "./ProjectOverviewBoard.vue?vue&type=script&lang=js"
export * from "./ProjectOverviewBoard.vue?vue&type=script&lang=js"

import "./ProjectOverviewBoard.vue?vue&type=style&index=0&id=c4534416&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4534416"]])

export default __exports__